const loadWebVitals = () => {
	if (process.env.NODE_ENV === 'test') {
		return Promise.resolve(require('web-vitals'));
	}

	return import('web-vitals');
};

const reportWebVitals = onPerfEntry => {
	if (typeof onPerfEntry === 'function') {
		return loadWebVitals().then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
			getCLS(onPerfEntry);
			getFID(onPerfEntry);
			getFCP(onPerfEntry);
			getLCP(onPerfEntry);
			getTTFB(onPerfEntry);
		});
	}

	return undefined;
};

export default reportWebVitals;
